import * as z from "zod/v4";

export const getOmsApparelMagicIntegration = {
  name: "getOmsApparelMagicIntegration" as const,
  input: z.object({}),
  output: z.object({
    exists: z.boolean(),
    enabled: z.boolean().optional(),
    usePickTicketNumberAsOrderName: z.boolean().optional(),
    autoInvoicePickTickets: z.boolean().optional(),
  }),
};
